import type { BlurbContext } from './types';

export const formatList = (items: string[]) => {
  if (items.length === 1) return items[0];
  if (items.length === 2) return items.join(' and ');
  return `${items.slice(0, -1).join(', ')}, and ${items.at(-1)}`;
};

export const mapValuesToText = <T extends string>(
  keys: T[],
  map: Record<T, string>,
): string[] => {
  if (!keys?.length) {
    return [];
  }

  return keys
    .map((key) => map[key])
    .filter((line): line is string => Boolean(line));
};

export const hasField = (ctx: BlurbContext, field: string) =>
  ctx.includedSections.has(field);

export const addField = (ctx: BlurbContext, field: string) =>
  ctx.includedSections.add(field);
